import React, { Suspense } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

type Props = {
  playerId: string;
  speeds: number[];
  positions: string[];
  client: string | undefined;
  camera: any;
};

export default function PlayerTypeSettings({ playerId, speeds, positions, client, camera }: Props) {
  const { control } = useFormContext();
  const loadModule = (type: string) => {
    return import(`./types/${type}`)
      .then((module) => {
        return module;
      })
      .catch(() => {
        return import(`./types/no-settings`);
      });
  };

  const type: string = useWatch({ name: 'type', control });
  const Settings = React.lazy(() => loadModule(type));
  return (
    <>
      <Suspense fallback={<div>Loading...</div>}>
        <Settings playerId={playerId} speeds={speeds} positions={positions} client={client} camera={camera} />
      </Suspense>
    </>
  );
}
